// extracted by mini-css-extract-plugin
export default {"contactBtn":"Contact_contactBtn__Keghu","contactDis":"Contact_contactDis__+iuJK"};